import styled from 'styled-components';
import { FlexboxProps, flexbox } from 'styled-system';
import { Box } from './Box';

export const Flex = styled(Box)<FlexboxProps>`
  ${flexbox}
`;

Flex.displayName = 'Flex';
Flex.defaultProps = {
  display: 'flex',
};
